module.exports = __webpack_public_path__ + "img/admin.c10930f6.png";